import React from "react";
import { Controller } from "react-hook-form";
import {
    Button,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Label,
    Spinner,
} from "reactstrap";
import Fade from "react-reveal/Fade";
import * as queryString from "query-string";
import { useLocation } from "react-router";

const FormFields = ({
    control,
    errors,
    taxExemption,
    isSubmitting,
    activeSelection,
    isRecurringPayment,
}) => {
    const location = useLocation();
    const { r } = queryString.parse(location.search);

    return (
        <>
            <Controller
                name="name"
                control={control}
                defaultValue=""
                rules={{ required: "Full Name is required" }}
                render={({ field: { onChange, value } }) => (
                    <FormGroup>
                        <Label htmlFor="name">Full Name</Label>
                        <Input
                            id="name"
                            className="form-control"
                            type="text"
                            placeholder=""
                            value={value}
                            onChange={onChange}
                        />
                        <span className="font-danger">
                            {errors?.name && errors?.name.message}
                        </span>
                    </FormGroup>
                )}
            />
            <Controller
                name="email"
                control={control}
                defaultValue=""
                rules={{ required: "Email Address is required" }}
                render={({ field: { onChange, value } }) => (
                    <FormGroup>
                        <Label htmlFor="email">Email Address</Label>
                        <Input
                            id="email"
                            className="form-control"
                            type="text"
                            placeholder=""
                            value={value}
                            onChange={onChange}
                        />
                        <span className="font-danger">
                            {errors?.email && errors?.email.message}
                        </span>
                    </FormGroup>
                )}
            />
            <Controller
                name="phone"
                control={control}
                defaultValue=""
                rules={{
                    required: "Phone Number is required",
                    pattern: /[A-Za-z]{3}/,
                }}
                render={({ field: { onChange, value } }) => (
                    <FormGroup>
                        <Label htmlFor="phone">Phone Number</Label>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>{"+91"}</InputGroupText>
                            </InputGroupAddon>
                            <Input
                                id="phone"
                                className="form-control"
                                type="text"
                                placeholder=""
                                maxLength="10"
                                value={value}
                                onChange={onChange}
                            />
                        </InputGroup>
                        <span className="font-danger">
                            {errors?.phone && errors?.phone.message}
                        </span>
                    </FormGroup>
                )}
            />
            <Controller
                name="taxExemption"
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value } }) => (
                    <FormGroup className="animate-chk">
                        <Label className="d-block" for="taxExemption">
                            <Input
                                className="checkbox_animated"
                                id="taxExemption"
                                type="checkbox"
                                value={value}
                                onChange={onChange}
                            />
                            Do you wish to receive Tax Exemption?
                        </Label>
                    </FormGroup>
                )}
            />
            <Fade top collapse when={taxExemption}>
                {/* <div style={{ marginBottom: "1rem" }}> */}
                <Controller
                    name="addressLineOne"
                    control={control}
                    rules={{
                        required: "Address Line One is required",
                    }}
                    defaultValue={r}
                    render={({ field: { onChange, value } }) => (
                        <FormGroup>
                            <Label htmlFor="addressLineOne">
                                Address Line One
                            </Label>{" "}
                            <span className="font-danger">
                                {errors?.addressLineOne &&
                                    errors?.addressLineOne.message}
                            </span>
                            <Input
                                id="addressLineOne"
                                className="form-control"
                                type="text"
                                placeholder=""
                                value={value}
                                onChange={onChange}
                            />
                        </FormGroup>
                    )}
                />
            </Fade>
            <Fade top collapse when={taxExemption}>
                <Controller
                    name="addressLineTwo"
                    control={control}
                    defaultValue={r}
                    render={({ field: { onChange, value } }) => (
                        <FormGroup>
                            <Label htmlFor="addressLineTwo">
                                Address Line Two
                            </Label>{" "}
                            <span className="font-danger">
                                {errors?.addressLineTwo &&
                                    errors?.addressLineTwo.message}
                            </span>
                            <Input
                                id="addressLineTwo"
                                className="form-control"
                                type="text"
                                placeholder=""
                                value={value}
                                onChange={onChange}
                            />
                        </FormGroup>
                    )}
                />
            </Fade>
            <Fade top collapse when={taxExemption}>
                <Controller
                    name="city"
                    control={control}
                    rules={{ required: "City is required" }}
                    defaultValue={r}
                    render={({ field: { onChange, value } }) => (
                        <FormGroup>
                            <Label htmlFor="city">City</Label>{" "}
                            <span className="font-danger">
                                {errors?.city && errors?.city.message}
                            </span>
                            <Input
                                id="city"
                                className="form-control"
                                type="text"
                                placeholder=""
                                value={value}
                                onChange={onChange}
                            />
                        </FormGroup>
                    )}
                />
            </Fade>
            <Fade top collapse when={taxExemption}>
                <Controller
                    name="state"
                    control={control}
                    rules={{ required: "State is required" }}
                    defaultValue={r}
                    render={({ field: { onChange, value } }) => (
                        <FormGroup>
                            <Label htmlFor="state">State</Label>{" "}
                            <span className="font-danger">
                                {errors?.state && errors?.state.message}
                            </span>
                            <Input
                                id="state"
                                className="form-control"
                                type="text"
                                placeholder=""
                                value={value}
                                onChange={onChange}
                            />
                        </FormGroup>
                    )}
                />
            </Fade>
            <Fade top collapse when={taxExemption}>
                <Controller
                    name="pincode"
                    control={control}
                    rules={{ required: "Pincode is required" }}
                    defaultValue={r}
                    render={({ field: { onChange, value } }) => (
                        <FormGroup>
                            <Label htmlFor="pincode">Pincode</Label>{" "}
                            <span className="font-danger">
                                {errors?.pincode && errors?.pincode.message}
                            </span>
                            <Input
                                id="pincode"
                                className="form-control"
                                type="text"
                                placeholder=""
                                value={value}
                                onChange={onChange}
                            />
                        </FormGroup>
                    )}
                />
            </Fade>
            <Fade top collapse when={taxExemption}>
                <Controller
                    name="pancard"
                    control={control}
                    rules={{ required: "Pancard is required" }}
                    defaultValue={r}
                    render={({ field: { onChange, value } }) => (
                        <FormGroup>
                            <Label htmlFor="pancard">Pancard</Label>{" "}
                            <span className="font-danger">
                                {errors?.pancard && errors?.pancard.message}
                            </span>
                            <Input
                                id="pancard"
                                className="form-control"
                                type="text"
                                placeholder=""
                                maxLength="10"
                                value={value}
                                onChange={onChange}
                            />
                        </FormGroup>
                    )}
                />
            </Fade>
            <Fade top collapse when={taxExemption}>
                <Controller
                    name="dateOfBirth"
                    control={control}
                    rules={{
                        required: "Date of Birth is required",
                    }}
                    defaultValue={r}
                    render={({ field: { onChange, value } }) => (
                        <FormGroup>
                            <Label htmlFor="dateOfBirth">Date of Birth</Label>{" "}
                            <span className="font-danger">
                                {errors?.dateOfBirth &&
                                    errors?.dateOfBirth.message}
                            </span>
                            <Input
                                id="dateOfBirth"
                                className="form-control"
                                type="text"
                                placeholder=""
                                value={value}
                                onChange={onChange}
                            />
                        </FormGroup>
                    )}
                />
                {/* </div> */}
            </Fade>
            {/* <Controller
                name="referenceCode"
                control={control}
                defaultValue={r}
                render={({ field: { onChange, value } }) => (
                    <FormGroup>
                        <Label htmlFor="referenceCode">
                            Reference Code (if available)
                        </Label>
                        <Input
                            id="referenceCode"
                            className="form-control"
                            type="text"
                            placeholder=""
                            value={value}
                            onChange={onChange}
                        />
                        <span className="font-danger">
                            {errors?.referenceCode &&
                                errors?.referenceCode.message}
                        </span>
                    </FormGroup>
                )}
            /> */}
            <Controller
                name="amount"
                control={control}
                defaultValue={activeSelection.amount}
                shouldUnregister={true}
                render={({ field: { onChange, value } }) => (
                    <FormGroup>
                        <Label htmlFor="amount">Donation Amount</Label>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>{"₹"}</InputGroupText>
                            </InputGroupAddon>
                            <Input
                                id="amount"
                                className="form-control"
                                type="text"
                                placeholder=""
                                value={value}
                                disabled
                            />
                        </InputGroup>
                    </FormGroup>
                )}
            />
            <Controller
                name="cause"
                control={control}
                defaultValue={activeSelection.cause}
                shouldUnregister={true}
                render={({ field: { onChange, value } }) => (
                    <Input
                        id="cause"
                        className="form-control"
                        type="hidden"
                        placeholder=""
                        value={value}
                        disabled
                    />
                )}
            />
            <Controller
                name="isRecurringPayment"
                control={control}
                defaultValue={isRecurringPayment}
                shouldUnregister={true}
                render={({ field: { onChange, value } }) => (
                    <Input
                        id="isRecurringPayment"
                        className="form-control"
                        type="hidden"
                        placeholder=""
                        value={value}
                        disabled
                    />
                )}
            />

            <Controller
                name="numberOfKids"
                control={control}
                defaultValue={activeSelection.numberOfKids}
                shouldUnregister={true}
                render={({ field: { onChange, value } }) => (
                    <Input
                        id="numberOfKids"
                        className="form-control"
                        type="hidden"
                        placeholder=""
                        value={value}
                        disabled
                    />
                )}
            />

            <Controller
                name="numberOfMonths"
                control={control}
                defaultValue={activeSelection.numberOfMonths}
                shouldUnregister={true}
                render={({ field: { onChange, value } }) => (
                    <Input
                        id="numberOfMonths"
                        className="form-control"
                        type="hidden"
                        placeholder=""
                        value={value}
                        disabled
                    />
                )}
            />

            <Button disabled={isSubmitting} type="submit" color="primary">
                {isSubmitting ? <Spinner size="sm" /> : "Submit"}
            </Button>
        </>
    );
};

export default FormFields;
